export default "__VITE_ASSET__YKhcJ4CQ__"